import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

const NavLinkButton = styled.a`
    ${BaseStyle.Mixins.fontStyles.ui['16m']};
    align-items: center;
    cursor: pointer;
    display: flex;
    height: ${({ fullsize }) => (fullsize ? '100%' : 'initial')};
    padding-bottom: 12px;
    text-transform: capitalize;

    && {
        color: ${({ theme }) => theme.Text.secondary};

        &.active {
            color: ${({ theme }) => theme.Text.primary};
        }

        &:hover {
            color: ${({ theme }) => theme.Text.primary};
        }
    }

    &.active {
        ${BaseStyle.Mixins.fontStyles.ui['16b']};
        border-bottom: 4px solid ${({ theme }) => theme.Surface.Opposite.primary};
        cursor: default;
    }
`;

export default NavLinkButton;
